/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { ReferralRewardThreshold } from './ReferralRewardThreshold';
import {
    ReferralRewardThresholdFromJSON,
    ReferralRewardThresholdFromJSONTyped,
    ReferralRewardThresholdToJSON,
    ReferralRewardThresholdToJSONTyped,
} from './ReferralRewardThreshold';

/**
 * 
 * @export
 * @interface GetReferralRewardThresholdsResponse
 */
export interface GetReferralRewardThresholdsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetReferralRewardThresholdsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<ReferralRewardThreshold>}
     * @memberof GetReferralRewardThresholdsResponse
     */
    referralRewardThresholds: Array<ReferralRewardThreshold>;
}

/**
 * Check if a given object implements the GetReferralRewardThresholdsResponse interface.
 */
export function instanceOfGetReferralRewardThresholdsResponse(value: object): value is GetReferralRewardThresholdsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('referralRewardThresholds' in value) || value['referralRewardThresholds'] === undefined) return false;
    return true;
}

export function GetReferralRewardThresholdsResponseFromJSON(json: any): GetReferralRewardThresholdsResponse {
    return GetReferralRewardThresholdsResponseFromJSONTyped(json, false);
}

export function GetReferralRewardThresholdsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReferralRewardThresholdsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'referralRewardThresholds': ((json['referralRewardThresholds'] as Array<any>).map(ReferralRewardThresholdFromJSON)),
    };
}

export function GetReferralRewardThresholdsResponseToJSON(json: any): GetReferralRewardThresholdsResponse {
    return GetReferralRewardThresholdsResponseToJSONTyped(json, false);
}

export function GetReferralRewardThresholdsResponseToJSONTyped(value?: GetReferralRewardThresholdsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'referralRewardThresholds': ((value['referralRewardThresholds'] as Array<any>).map(ReferralRewardThresholdToJSON)),
    };
}

